<template>
  <div style="padding-right: 10px;display: inline-block;vertical-align: middle">
    <div style="display: flex;justify-content: space-between;">
      <div v-for="(item,index) in resultList" :key="index">
        <charge-count-item-renderer :item="item" />
      </div>
    </div>
  </div>
</template>

<script>
import ChargeCurrencyTotalGroupHP from './ChargeCurrencyTotalGroupHP.js'
import ChargeCountItemRenderer from './ChargeCountItemRenderer'
export default {
  name: 'ChargeCurrencyTotalGroup',
  components: { ChargeCountItemRenderer },
  props: {
    type: { type: String, default: 'all' },
    dataProvider: { type: Array, default: () => [], required: false }, // 数据源
    showControlled: { type: Boolean, default: true }, // 应付受控
    showCostControlled: { type: Boolean, default: true },
    dataField: { type: String, default: 'amount' },
    amountToCurrency: { type: String, default: null }, // 折合币种
    amountToCurrencyLabel: { type: String, default: '' }, // 折合标签
    arLabel: { type: String, default: '' },
    apLabel: { type: String, default: '' },
    currencyField: { type: String, default: 'currency' },
    rateField: { type: String, default: 'rate' }, // 汇率，如果不取系统汇率而是取数据源中的汇率时使用。
    arField: { type: String, default: 'receivable' }, // 收付字段
    isAr: { type: Boolean, default: true }, // 是否应收在auto模式下有用
    arapGroup: { type: Boolean, default: false }, // 是否分实收实付
    mode: { type: String, default: 'group' },
    source: { type: String, default: '' },
    arapOrder: { type: String, default: ChargeCurrencyTotalGroupHP.AR }, // 应收应付计算顺序 defaultValue="ar", enumeration="ar,ap"
    showControlledProfit: { type: Boolean, default: false },
    isGrossProfit: { type: Boolean, default: false },
    auxiliaryMap: { type: Map, default: () => null, required: false }, // 辅助性数据源，用来处理额外的判断
    showWht: { type: Boolean, default: false }, // 是否需要展示去Wht金额
    currencyConversionInInvoices: { type: Boolean, default: false }, // 通过参数控制发票中费用币种转化计算模式
    onlyShowConvert: { type: Boolean, default: false } // 是否仅展示折合
  },
  data() {
    return {
      chargeCurrencyTotalGroupHP: null,
      resultList: [],
      chargeCurrencyTotalGroupData: {}
    }
  },
  computed: {
  },
  watch: {
    dataProvider(val) {
      this.chargeCurrencyTotalGroupHP.dataProvider = val
      this.chargeCurrencyTotalGroupHP.auxiliaryMap = this.auxiliaryMap
      this.chargeCurrencyTotalGroupHP.recalc()
    },
    dataField(val) {
      this.chargeCurrencyTotalGroupHP.dataField = val
      this.chargeCurrencyTotalGroupHP.auxiliaryMap = this.auxiliaryMap
      this.chargeCurrencyTotalGroupHP.recalc()
    },
    showControlledProfit(val) {
      this.chargeCurrencyTotalGroupHP.showControlledProfit = val
      this.chargeCurrencyTotalGroupHP.auxiliaryMap = this.auxiliaryMap
      this.chargeCurrencyTotalGroupHP.recalc()
    },
    resultList(val) {
      this.$emit('callback', val)
    }
  },
  created() {
    this.chargeCurrencyTotalGroupData = {
      type: this.type,
      dataProvider: this.dataProvider, // 数据源
      showControlled: this.showControlled,
      showCostControlled: this.showCostControlled,
      dataField: this.dataField,
      amountToCurrency: this.amountToCurrency,
      amountToCurrencyLabel: this.amountToCurrencyLabel,
      arLabel: this.arLabel,
      apLabel: this.apLabel,
      currencyField: this.currencyField,
      rateField: this.rateField,
      source: this.source,
      arField: this.arField,
      isAr: this.isAr,
      arapGroup: this.arapGroup,
      mode: this.mode,
      arapOrder: this.arapOrder,
      showControlledProfit: this.showControlledProfit,
      isGrossProfit: this.isGrossProfit,
      resultList: this.resultList,
      auxiliaryMap: this.auxiliaryMap,
      showWht: this.showWht,
      currencyConversionInInvoices: this.currencyConversionInInvoices,
      onlyShowConvert: this.onlyShowConvert
    }
    this.chargeCurrencyTotalGroupHP = new ChargeCurrencyTotalGroupHP(this.chargeCurrencyTotalGroupData)
    this.chargeCurrencyTotalGroupHP.recalc()
  },
  methods: {

  }

}
</script>

<style scoped>

</style>
